<script lang="ts" setup>
const { isMobile } = useBSBreakpoints()
</script>

<template>
  <UiSection
    id="partnerships"
    class="partnerships"
  >
    <div class="section__container">
      <div class="section__row">
        <div class="section__col section__col--text">
          <UiHeader :header="$t('responsibleBusiness.section6.header')" />

          <picture
            v-if="isMobile"
            class="section__picture"
          >
            <source
              media="(width < 1200px)"
              srcset="/images/responsible-business/benefitsystems-responsible-partnership_d.webp"
            >

            <source
              media="(width >= 1200px)"
              srcset="/images/responsible-business/benefitsystems-responsible-partnership_d.webp"
            >

            <img
              src="/images/responsible-business/benefitsystems-responsible-partnership_d.webp"
              :alt="$t('responsibleBusiness.section6.header')"
            >
          </picture>

          <p class="partnerships__text">
            {{ $t('responsibleBusiness.section6.textSecond') }}
          </p>
        </div>

        <div
          v-if="!isMobile"
          class="section__col section__col--img"
        >
          <picture class="section__picture">
            <source
              media="(width < 1200px)"
              srcset="/images/responsible-business/benefitsystems-responsible-partnership_d.webp"
            >
            <source
              media="(width >= 1200px)"
              srcset="/images/responsible-business/benefitsystems-responsible-partnership_d.webp"
            >
            <img
              src="/images/responsible-business/benefitsystems-responsible-partnership_d.webp"
              :alt="$t('responsibleBusiness.section6.header')"
            >
          </picture>
        </div>
      </div>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
:deep(.section) {
  margin-bottom: 0;
}

.partnerships {
  padding-bottom: 0;

  :deep(.ui-header) {
    margin-bottom: 3.2rem;
  }

  &__text {
    @include h10;
    margin-bottom: 5.6rem;
  }

  .section__col--img {
    text-align: center;
  }

  .section__col--text {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .section__picture {
    img {
      margin-bottom: 3.2rem;
      border-radius: 1.6rem;
    }
  }
}

@include atM {

  .partnerships {
    margin-bottom: 0;
    padding-bottom: 9rem;

    &__text {
      @include h9;
    }
  }
}
</style>
